<template>
  <div class="page-nvidani" >
    <el-carousel
      class="common-focus"
      :interval="5000"
      arrow="always"
      trigger="click"
    >
      <el-carousel-item
        v-for="(item, index) in banners"
        :key="index"
      >
        <a :href="item.link"
           target="_blank"
           @click="setBD(item, index)"
           class="focus-item"
           :style="{backgroundImage: 'url(' + item.content + ')'}">
        </a>
      </el-carousel-item>
    </el-carousel>

    <div class="ncom-title common-wrap">
      <a :href="baseUrl+'/filmdetail?id='+secId" target="_blank" class="item-wrap"><span class="fir">放映厅</span></a>
      <span class="sec">人人动画平台自制的大型中国历史故事动画剧集</span>
    </div>



    <filmPart :secId="secId"  v-if="isReloadFilmPart"></filmPart>

    <div class="nvidani-content left-right-content clearfix">
      <div class="c-left">
        <div class="ntradition-images-wrap clearfix">
          <a :href="baseUrl+'/filmdetail?id='+secId" class="img-item"  style="cursor: pointer">
            <img :src="require('@/assets/images/ntradition_img01.jpg')" alt="">
          </a>
          <a :href="baseUrl+'/nTradition?plate=2'"  class="img-item" style="cursor: pointer">
            <img :src="require('@/assets/images/ntradition_img04.jpg')" alt="">
          </a>
          <a :href="baseUrl+'/nAnimateMake?plate=3'" class="img-item" style="cursor: pointer">
            <img :src="require('@/assets/images/ntradition_img03.jpg')" alt="">
          </a>
        </div>

        <div class="ncom-title">
          <a :href="baseUrl+'/productionList?choicenessType=1&plate=1'"  target="_blank" class="fir">经典获奖动画短片精选</a>
        </div>
        <div class="ncourse-wrap clearfix" v-show="isMounted">

          <div class="ncourse-item" :title="item.productionName" v-for="(item,index) in newIndexVideoProductionOneList" :key="index">
            <a :href="baseUrl+'/worksdetail?id='+item.id+'&plate='+item.belongSection" class="course-img" target="_blank"
              :style="{backgroundImage: 'url(' + item.productionCover + ')'}"
            >
            </a>
            <div class="course-info">
              <a :href="baseUrl+'/worksdetail?id='+item.id+'&plate='+item.belongSection" class="tit" target="_blank">{{item.productionName}}</a>
              <div class="views-user clearfix">
                <div class="view-much clearfix">
                  <i class="icon-view"></i>
                  <span class="count">{{item.viewCount}}</span>
                </div>
                <a :href="baseUrl+'/home?userId='+item.creatorId" target="_blank" class="user-info">
                  <img class="usr-avatar" :src="item.imgUrl" alt="" />
                  <span class="usr-name">{{ item.creatorName }}</span>
                </a>
              </div>
            </div>
          </div>



        </div>

        <div class="ncom-title">
          <a :href="baseUrl+'/productionList?choicenessType=2&plate=1'"   target="_blank"  class="fir">国内优秀动画短片精选</a>
        </div>
        <div class="ncourse-wrap clearfix" v-show="isMounted">


          <div class="ncourse-item" :title="item2.productionName" v-for="(item2,index) in newIndexVideoProductionTwoList" :key="index">
            <a :href="baseUrl+'/worksdetail?id='+item2.id+'&plate='+item2.belongSection" target="_blank" class="course-img"
              :style="{backgroundImage: 'url(' + item2.productionCover + ')'}"
            >
            </a>
            <div class="course-info">
              <a :href="baseUrl+'/worksdetail?id='+item2.id+'&plate='+item2.belongSection"  class="tit" target="_blank">{{item2.productionName}}</a>
              <div class="views-user clearfix">
                <div class="view-much clearfix">
                  <i class="icon-view"></i>
                  <span class="count">{{item2.viewCount}}</span>
                </div>
                <a :href="baseUrl+'/home?userId='+item2.creatorId" target="_blank" class="user-info">
                  <img class="usr-avatar" :src="item2.imgUrl" alt="" />
                  <span class="usr-name">{{ item2.creatorName }}</span>
                </a>
              </div>
            </div>
          </div>

        </div>

        <div class="ncom-title">
          <a :href="baseUrl+'/productionList?choicenessType=3&plate=1'"target="_blank"  class="fir">传统文化动画精选</a>
        </div>
        <div class="ncourse-wrap clearfix" v-show="isMounted">

          <div class="ncourse-item" :title="item3.productionName"  v-for="(item3,index) in newIndexVideoProductionThreeList" :key="index">
            <a :href="baseUrl+'/worksdetail?id='+item3.id+'&plate='+item3.belongSection" class="course-img" target="_blank"
                    :style="{backgroundImage: 'url(' + item3.productionCover + ')'}"
            >
            </a>
            <div class="course-info">
              <a :href="baseUrl+'/worksdetail?id='+item3.id+'&plate='+item3.belongSection" class="tit" target="_blank">{{item3.productionName}}</a>
              <div class="views-user clearfix">
                <div class="view-much clearfix">
                  <i class="icon-view"></i>
                  <span class="count">{{item3.viewCount}}</span>


                </div>
                <a :href="baseUrl+'/home?userId='+item3.creatorId" target="_blank" class="user-info">
                  <img class="usr-avatar" :src="item3.imgUrl" alt="" />
                  <span class="usr-name">{{ item3.creatorName }}</span>
                </a>
              </div>
            </div>
          </div>


        </div>
        
      </div>
      <div class="c-right">
        <div class="one-item">
          <div class="one-title">
            推荐关注
            <i class="el-icon-refresh-right shuaxin" v-on:click="getRankUser"></i>
          </div>
          <div class="user-list clearfix">
            <div class="dv-user" v-for="(item, index) in userList" :key="index">
              <div class="u-head">
                <router-link
                        :to="{ path: '/home', query: { userId: item.userId } }"
                        target="_blank"
                        class="avatar-f">
                  <img :src="`http://iss.21teacher.com/avatar/125/${item.userId}/20.jpg`" alt="" />
                </router-link>
                <i
                        class="el-icon-plus zt"
                        v-on:click="followEvent(index, item.userId)"
                        v-if="userList[index].followFlag == false"
                ></i>
                <i
                        class="el-icon-check zt"
                        v-if="userList[index].followFlag == true"
                ></i>
                <div class="new-tchh clearfix"
                     v-if="item.userRankName != '' && item.userRankName != null">
                  <i  class="bs zs"  title="资深作者"
                      v-if="userList[index].userRankName.split(',')[1] == '资深作者'"
                  ></i>
                  <i
                          class="bs yx"  title="优秀作者"
                          v-if="item.userRankName.split(',')[1] == '优秀作者'"
                  ></i>
                  <i
                          class="bs hy" title="活跃作者"
                          v-if="item.userRankName.split(',')[1] == '活跃作者'"
                  ></i>
                </div>

                <!-- 优秀作者 -->
                <!-- <i class="bs yx" title="优秀作者"></i>  -->
                <!-- 活跃作者 -->
                <!-- <i class="bs hy" title="活跃作者"></i> -->
              </div>
              <div class="user-name">{{ item.userName }}</div>
              <div class="tag" v-if="item.signature != null && item.signature != ''" :title="item.signature">
                {{ item.signature }}
              </div>
              <div class="tag" v-if="item.signature == null || item.signature ==''">暂无签名</div>
            </div>



          </div>
        </div>
        <div class="one-item"  v-if="rParam.total > 0">
          <div class="one-title">
            热门作品
            <i class="el-icon-refresh-right shuaxin" @click="getRecommendList()"></i>
          </div>
          <div class="works-list">

            <router-link :to="{ path: '/worksdetail', query: { id: item.id,plate:item.belongSection  } }"
                         class="item" target="_blank" :title="item.productionName"
                         v-for="(item, index) in rList" :key="index">
              <div class="work-img-f">
                <img :src="item.productionCover" alt="">
                <!--<div class="mask"><i class="el-icon-video-play play-icon"></i></div>-->
              </div>
              <div :title="item.productionName" class="work-title">
                {{ item.productionName }}
              </div>
            </router-link>

          </div>
        </div>
        <div class="one-item" v-if="cParam.total > 0">
          <div class="one-title">
            精选作品
            <i class="el-icon-refresh-right shuaxin" @click="getChoicenessList()"></i>
          </div>


          <div class="works-list">
            <router-link :to="{ path: '/worksdetail', query: { id: item.id,plate:item.belongSection } }"
                         :title="item.productionName" class="item" target="_blank"
                         v-for="(item, index) in cList" :key="index">
              <div class="work-img-f">
                <img :src="item.productionCover" alt="">
               <!-- <div class="mask"><i class="el-icon-video-play play-icon"></i></div>-->
              </div>
              <div :title="item.productionName" class="work-title">
                {{item.productionName}}
              </div>
            </router-link>

            <!--<router-link to="" class="item" target="_blank">
              <div class="work-img-f">
                <img src="http://ocs.21teacher.com/dir-image/2020/11/12/0a0ac1d4dc674851b74d22f4e17b7424.jpg" alt="">
                <div class="mask"><i class="el-icon-video-play play-icon"></i></div>
              </div>
              <div title="先来一个神话故事" class="work-title">
                先来一个神话故事
              </div>
            </router-link>-->

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import updateTdk from "@/utils/tdk";
  import productionApi from "@/api/production";
  import filmPart from "@@/pub/film/filmPart";
  import apiService from "@/api/index";
  import { mapState } from 'vuex'

  export default {
    components: {
      filmPart
    },
    computed: {
      ...mapState(['newIndexVideoProductionOneList','newIndexVideoProductionTwoList','newIndexVideoProductionThreeList'])
    },
    data () {
      return {
        baseUrl:process.env.config.RRDH_HOST,

        headTitle: "人人动画",
        headKeywords: "keywords---rrdh",
        headDesc: "description---rrdh",
        isMounted: false, //for control not ssr render

        isReloadFilmPart:false,
        secId:Number(process.env.config.VUE_APP_RR_SID),

        productionParam:{
          deleteFlag: 0,
          pageIndex: 1,
          pageSize: 6,
          productionForm:2, //视频
          belongSection:1,//动画短片 1  ///  传统文化 2 ///  动画制作 3
          choicenessType:1 , //经典获奖 1  ///  国内优秀  2  ////  传统文化 3
          productionType:"",
        },
        productionData1:[],
        productionData2:[],
        productionData3:[],

        productionParam1:{
          deleteFlag: 0,
          pageIndex: 1,
          pageSize: 6,
          productionForm:2, //视频
          belongSection:1,//动画短片 1  ///  传统文化 2 ///  动画制作 3
          choicenessType:1 , //经典获奖 1  ///  国内优秀  2  ////  传统文化 3
          productionType:"",
        },
        productionParam2:{
          deleteFlag: 0,
          pageIndex: 1,
          pageSize: 6,
          productionForm:2, //视频
          belongSection:1,//动画短片 1  ///  传统文化 2 ///  动画制作 3
          choicenessType:2 , //经典获奖 1  ///  国内优秀  2  ////  传统文化 3
          productionType:"",
        },
        productionParam3:{
          deleteFlag: 0,
          pageIndex: 1,
          pageSize: 6,
          productionForm:2, //视频
          belongSection:1,//动画短片 1  ///  传统文化 2 ///  动画制作 3
          choicenessType:3 , //经典获奖 1  ///  国内优秀  2  ////  传统文化 3
          productionType:"",
        },
        banners: [],

        queryParam: {},
        userList: [],


        ///////页面 右侧
        //choiceness 精选
        cParam:{
          total:0,
          deleteFlag: 0,
          pageIndex: 1,
          pageSize: 2,
          time: new Date().getMilliseconds(),
          //productionForm:2, //视频
          belongSection:1,//动画短片 1  ///  传统文化 2 ///  动画制作 3
          isChoiceness:1,
        },
        cList:[],
        //recommend 推荐
        rParam:{
          total:0,
          deleteFlag: 0,
          pageIndex: 1,
          pageSize: 2,
          productionForm:2, //视频
          belongSection:1,//动画短片 1  ///  传统文化 2 ///  动画制作 3
          recommend:1
        },
        rList:[],
      }
    },

    tdk() {
      return {
        title: this.headTitle,
        description: this.headDesc,
        keywords: this.headKeywords,
        ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
      };
    },
    serverPrefetch() {
      return this.initData();
    },
    // beforeRouteUpdate(to, from, next) {
    //   // 一般建议路由变更采用计算属性或者store直接绑定
    //   // 特殊情况处理可以采用如下方案 重新注册数据返回处理
    //   this.initData()
    //   next();
    // },


    mounted(){

      const alreadyProductionOne = !!this.newIndexVideoProductionOneList
      const alreadyProductionTwo = !!this.newIndexVideoProductionTwoList
      const alreadyProductionThree = !!this.newIndexVideoProductionThreeList

      // console.log("alreadyProductionOne===========",alreadyProductionOne)
      // console.log("alreadyProductionTwo===========",alreadyProductionTwo)
      // console.log("alreadyProductionThree===========",alreadyProductionThree)
      if (!alreadyProductionOne || !alreadyProductionTwo ||!alreadyProductionThree) {
        this.initData().then(()=>{
          setTimeout(()=>{
            this.fetchData()
          },3000)
        })
      }else{
        //this.parseHtml(this.newIndexStoryList)
        this.fetchData()
      }



      //this.isMounted = true;

      this.callbackurl = "login?callback=" + window.location.href;
      /*
          setTimeout(()=>{
            this.isReloadFilmPart = true
            this.getRankUser()
            this.initData()
            this.getChoicenessList()
            this.getRecommendList()
            this.getBanners();
          },1500)
      */

    },
    methods: {
      fetchData(){
        setTimeout(()=>{
          this.isMounted = true;
          this.isReloadFilmPart = true
          this.getRankUser()
          this.getChoicenessList()
          this.getRecommendList()
          this.getBanners();
        },1000)
      },

      getBanners() {
        this.queryParam = { time: new Date().getMilliseconds(),plate:1 };
        apiService.getBannerData(this.queryParam).then(data => {
          const re = data;
          this.banners = re.response;
          this.fullscreenLoading = false;
        });
      },
      initData(){
        this.$loading(true)
        const cookies = this.$ssrContext && this.$ssrContext.cookies
        this.$store.dispatch("FETCH_NEW_INDEX_VIDEO_PRODUCTION_TWO_LIST", {params: this.productionParam2}, { cookies });
        this.$store.dispatch('FETCH_NEW_INDEX_VIDEO_PRODUCTION_THREE_LIST', {params: this.productionParam3}, { cookies });
        return this.$store.dispatch("FETCH_NEW_INDEX_VIDEO_PRODUCTION_ONE_LIST", {params: this.productionParam1,cookies:cookies}).finally(() => {
          this.$loading(false)
          this.setSeo();
          updateTdk.call(this);
        })
      },
      setSeo() {
        this.headTitle = "人人动画网【官网】";
        this.headKeywords = "人人动画网,动画短视频,短视频";
        this.headDesc =
                "人人动画网，是一个动画短视频分享社区，凭借丰富的快速动画创意资源，和行业深厚的动画技术背景，助力每个人实现自己的动画梦。";
      },

      // getProduction(choicenessType){
      //   let thiss = this
      //
      //   if(choicenessType == 1){
      //     thiss.productionParam.choicenessType = choicenessType
      //     productionApi.pageV2IndexList(this.productionParam).then(rePro => {
      //       thiss.productionData1 = rePro.list
      //       thiss.getProduction(2)
      //     })
      //   }else if(choicenessType == 2){
      //     this.productionParam.choicenessType = choicenessType
      //     productionApi.pageV2IndexList(this.productionParam).then(rePro => {
      //       thiss.productionData2 = rePro.list
      //       thiss.getProduction(3)
      //     })
      //   } else {
      //     this.productionParam.choicenessType = choicenessType
      //     productionApi.pageV2IndexList(this.productionParam).then(rePro => {
      //       thiss.productionData3 = rePro.list
      //     })
      //   }
      //
      // },
      getRankUser() {
        this.fullscreenLoading = true;
        this.queryParam = { time: new Date().getMilliseconds() };
        apiService.getRankUser(this.queryParam).then(data => {
          const re = data;
          this.userList = re.response;
          this.fullscreenLoading = false;
        });
      },
      followEvent(index,id){
        var _this =this;
        apiService.addFollow(id).then(data => {
          _this.userList[index].followFlag = true;
        })
      },
      reloadPage(page){
        window.location.href=page;
      },


      //右侧列表方法
      //精选
      getChoicenessList() {
        //this.cParam.productionType=this.productionParam.productionType
        productionApi.getProductionPageRightList(this.cParam).then(data => {
          this.cList=data.response.list;
          this.cParam.total = data.response.total
          if(this.cParam.pageIndex == Math.ceil(this.cParam.total/this.cParam.pageSize)){
            this.cParam.pageIndex =1
          }else{
            this.cParam.pageIndex = this.cParam.pageIndex +1
          }
        })
      },

      //推荐
      getRecommendList() {
        //this.rParam.productionType=this.productionParam.productionType
        productionApi.getProductionPageRightList(this.rParam).then(data => {
          this.rList=data.response.list;
          this.rParam.total = data.response.total
          if(this.rParam.pageIndex == Math.ceil(this.rParam.total/this.rParam.pageSize)){
            this.rParam.pageIndex =1
          }else{
            this.rParam.pageIndex = this.rParam.pageIndex +1
          }
        })
      },
      setBD(item, index) {
        if (index == 0) {
          window._hmt.push([
            "_trackEvent",
            "banner1点击",
            "click_Banner",
            item.link
          ]);
        } else if (index == 1) {
          window._hmt.push([
            "_trackEvent",
            "banner2点击",
            "click_Banner",
            item.link
          ]);
        } else if (index == 2) {
          window._hmt.push([
            "_trackEvent",
            "banner3点击",
            "click_Banner",
            item.link
          ]);
        }
      },

    }
  }
</script>


<style>
  .yh-popo{
    padding: 0;
    background: none;
    border: none;
    box-shadow: none;
  }
</style>
<style scoped lang="less">
@import "../../film/detail/filmdetail.less";
.page-nvidani {
  padding-top: @NAVHEIGHT;
  .nvidani-content{
    .c-left{
      background: none;
    }
  }
}
</style>
